import React, { FC, RefObject } from 'react'
import classnames from 'classnames'
import style from './ClearIndicator.module.css'
import { ArrowIcon } from './components/ArrowIcon'

type ClearIndicatorProps = {
  valueChange(currentValue: string): void
  inputRef: RefObject<HTMLInputElement>
  disabled: boolean
}

export const ClearIndicator: FC<ClearIndicatorProps> = ({ valueChange, inputRef, disabled }) => {
  const className = classnames(style.clearIndicator, {
    [style.disabled]: disabled,
  })

  const onClick = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  return (
    <button
      type="button"
      className={className}
      data-creatableselectfield
      onMouseDown={() => valueChange('')}
      onClick={onClick}
      disabled={disabled}
    >
      <ArrowIcon className={style.clearIndicatorImage} />
    </button>
  )
}

ClearIndicator.displayName = 'ClearIndicator'
